import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Loader from "../../components/NewView/Common/Loader";
const CourseDetailsComponent = React.lazy(() =>
  import("../../components/NewView/RootComponents/CourseDetailsComponent")
);
const CourseDetailsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>
            YellowHub
          </title>
          <meta
            name="description"
            content="Next LMS - Professional LMS Online Education Course
            React Template"
          />
        </Helmet>
        <CourseDetailsComponent />
      </Suspense>
    </Fragment>
  );
};

export default CourseDetailsPage;
